<template>
<div class="mainScreen container-fluid custom-container-others">
    <!-- <div class="alert alert-danger alert-dismissible fade show top-alert text-center border-0 mb-0" role="alert">
    <span class="mr-3 top-icon"><i class="fas fa-video text-white video-icon pt-2"></i></span><span class="top-alert-message">We are offering Video Consultation and Classes.<strong>Know  more</strong></span>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div> -->
<HelloWorld />
<div class="row">
<div class="col-md-8">
<Categories />
</div>
<div class="col-md-4">
<NonEmptyCart />
</div>
</div>
</div>
</template>

<script>
import HelloWorld from './HelloWorld'
import Categories from './Categories'
import NonEmptyCart from './NonEmptyCart'

export default{
    name: 'App',
    components: {
        HelloWorld,
        Categories,
        NonEmptyCart
        
    },
    created() {
        window.addEventListener('beforeunload',this.handler)
        
    },
    methods : {
        handler: function(){
            window.scrollTo(0,0)
        }
    }

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
